import { render, staticRenderFns } from "./Titleimg.vue?vue&type=template&id=25e6e22d&scoped=true&"
import script from "./Titleimg.vue?vue&type=script&lang=js&"
export * from "./Titleimg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e6e22d",
  null
  
)

export default component.exports